export default {
  breakpoints: {
    extraTiny: 320,
    tiny: 576,
    small: 768,
    medium: 992,
    large: 1200,
    extraLarge: 1600,
  },
  validatorDictinary: {
    en: {
      messages: {
        regex: 'Password must contain both uppercase & lowercase letter, number and special character.'
      }
    }
  },
  // passwordRegex: /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[`~;:'"|(){}[\]<>,./\\\-_=+@$!%*?&#^])[A-Za-z\d`~;:'"|(){}[\]<>,./\\\-_=+@$!%*?&#^]{8,}$/,
  passwordRegex: /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[\W])[A-Za-z\d\W]{8,}$/,
  CustomerDocumentsOrders: {
    "photo-id": 1,
    "proof-of-address": 2,
    "other": 3
  }
};



